'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
require('../../../components/Card/Card.js');
require('../../../components/Card/CardBody.js');
require('../../../components/Card/CardFooter.js');
require('../../../components/Card/CardHeader.js');
var CardHeaderAddon = require('../../../components/Card/CardHeaderAddon.js');
require('../../../components/Card/CardEditButton.js');
require('../../../components/Card/CardHeaderEditButton.js');
require('../../../components/Card/CardFooterEditButton.js');
require('../../../components/Card/CardEmpty.js');

/**
 * Edit card header addon
 *
 * Provides layout for elements in the header.
 */
var EditCardHeaderAddon = CardHeaderAddon.CardHeaderAddon;
EditCardHeaderAddon.displayName = 'EditCardHeaderAddon';
exports.EditCardHeaderAddon = EditCardHeaderAddon;